import { createTheme, lighten, darken } from '@material-ui/core/styles';

import type { AlertClassKey } from '@material-ui/lab/Alert';

declare module '@material-ui/core/styles/overrides' {
  export interface ComponentNameToClassKey {
    MuiAlert: AlertClassKey;
  }
}

export const colors = {
  primary: process.env.REACT_APP_THEME_PRIMARY || '#587B9F',
  black: '#000',
  white: '#FFF',
  green: '#6CAE75',
  red: '#EF5350',
  orange: '#EF8950',
  yellow: '#FAB635',
  maroon: '#9F587C',
  blue: '#587B9F',
  toolBarColor: process.env.REACT_APP_THEME_TOOLBAR || '#294F70',
};

const theme = createTheme({
  overrides: {
    MuiLinearProgress: {
      determinate: {
        backgroundColor: lighten(colors.green, 0.5),
        color: colors.white,
      },
      bar1Determinate: {
        backgroundColor: colors.green,
        color: colors.white,
      },
    },
    MuiAlert: {
      standardInfo: {
        color: colors.primary,
        backgroundColor: lighten(colors.primary, 0.75),
      },
    },
    MuiButton: {
      containedPrimary: {
        color: colors.white,
        backgroundColor: colors.green,
        '&:hover': {
          backgroundColor: lighten(colors.green, 0.5),
        },
        fontWeight: 500,
      },
      textSecondary: {
        color: colors.red,
        backgroundcolor: colors.white,
        fontWeight: 500,
      },
      containedSecondary: {
        color: colors.white,
        backgroundColor: colors.red,
        '&:hover': {
          backgroundColor: lighten(colors.red, 0.5),
        },
        fontWeight: 500,
      },
    },
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: colors.toolBarColor,
        color: colors.white,
        height: 52,
      },
    },
    MuiToolbar: {
      root: {
        minHeight: 52,
        maxHeight: 52,
      },
      regular: {
        backgroundColor: colors.toolBarColor,
        color: colors.white,
        minHeight: 52,
        maxHeight: 52,
      },
    },
  },
  palette: {
    primary: {
      main: colors.primary,
      light: lighten(colors.primary, 0.5),
      dark: darken(colors.primary, 0.5),
    },
    error: {
      main: colors.red,
    },
  },
  typography: {
    fontFamily: ['Roboto', 'Roboto Condensed', 'sans-serif'].join(','),
    fontSize: 14,

  },
});

export default theme;
